import unzipFile from '../../helper/unzip';
import JSZipUtils from 'jszip-utils';
import apiProcess from '../../api/utility'
import {
  getAndesAdsResultEyeDiagram,
  getAndesAdsResultHistoryEyeDiagram,
  getAndesEndToEndAdsEyeDiagram,
  getAndesEndToEndAdsHisEyeDiagram,
  getAndesHspiceResultEyeDiagram,
  getHistoryChannelResultList,
  getAndesHspiceResultEyeParameters,
  getAndesAdsResultEyeParameters,
  getAndesAdsResultHistoryEyeParameters,
  getAndesEndToEndAdsEyeParameters,
  getEndToEndAndesAdsHistoryEyeParameters,
  generateEyeDiagram,
  getEndToEndChannelResultList,
  getChannelBathtubRawFile,
  getEndToEndBathtubRawFile,
  getSweepTDRSBRSetting,
  getEndToEndTDRSBRSetting,
  getTDRSBRSetting,
  generateSweepTDRSBR,
  generateEndToEndTDRSBR,
  generateTDRSBR,
  getHistoryEndToEndChannelResultList
} from '../../api/Andes_v2/result';

export function getChannelsEyeZip(id, resultType) {
  const token = localStorage.getItem('token');
  if (resultType === "current") {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(`/api/v3/andes/channel/result/seasim?channelId=${id}&access_token=${token}`, (error, data) => {
        if (error || !data.byteLength) {
          resolve(null);
        }
        resolve(data);
      });
    })
  } else {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(`/api/v3/andes/result/history/seasim?historyId=${resultType}&access_token=${token}`, (error, data) => {
        if (error || !data.byteLength) {
          resolve(null);
        }
        resolve(data);
      });
    })
  }
}

export function getEndToEndChannelsEyeZip(id, resultType) {
  const token = localStorage.getItem('token');
  if (resultType === "current") {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(`/api/v3/andes/end-to-end/channel/result/seasim?endToEndChannelId=${id}&access_token=${token}`, (error, data) => {
        if (error || !data.byteLength) {
          resolve(null);
        }
        resolve(data);
      });
    })
  } else {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(`/api/v3/andes/end-to-end/channel/result/seasim?endToEndChannelId=${id}&access_token=${token}`, (error, data) => {
        if (error || !data.byteLength) {
          resolve(null);
        }
        resolve(data);
      });
    })
  }
}

export function getChannelsEye(id, resultType) {
  return new Promise((resolve, reject) => {
    getChannelsEyeZip(id, resultType).then(res => {
      if (!res) {
        resolve(null); return;
      }
      unzipFile(res, "arraybuffer").then(response => {
        const keys = Object.keys(response);
        if (keys && keys.length) {
          resolve(response);
        } else {
          resolve(null)
        }
      }, error => {
        resolve(null);
      })
    })
  })
}

export function getEndToEndChannelEye(id, resultType) {
  return new Promise((resolve, reject) => {
    getEndToEndChannelsEyeZip(id, resultType).then(res => {
      if (!res) {
        resolve(null); return;
      }
      unzipFile(res, "arraybuffer").then(response => {
        const keys = Object.keys(response);
        if (keys && keys.length) {
          resolve(response);
        } else {
          resolve(null)
        }
      }, error => {
        resolve(null);
      })
    })
  })
}

//如果responseType 是arraybuffer 则返回的是二进制数据
function getResDataArrayBuffer(fn, params) {
  return new Promise((resolve, reject) => {
    fn(params).then(res => {
      if (res && res.data && res.data.byteLength) {
        resolve(res.data);
      }
      resolve(null);
    }, error => {
      resolve(null);
    })
  })
}

function getResData(fn, params) {
  return new Promise((resolve, reject) => {
    fn(params).then(res => {
      if (res && res.data) {
        resolve(res.data);
      }
      resolve(null);
    }, error => {
      resolve(null);
    })
  })
}

// ADS eye diagram - channel
export async function getAdsResultEyeDiagram({ channelId, signal, probe }) {
  return await getResDataArrayBuffer(getAndesAdsResultEyeDiagram, { channelId, signal, probe });
}

export async function getAdsResultHistoryEyeDiagram({ historyId, signal, probe }) {
  return await getResDataArrayBuffer(getAndesAdsResultHistoryEyeDiagram, { historyId, signal, probe });
}

export async function getAdsResultEyeParameters({ channelId, signal, probe }) {
  return await getResData(getAndesAdsResultEyeParameters, { channelId, signal, probe }, false, false, true);
}

export async function getAdsResultHistoryEyeParameters({ historyId, signal, probe }) {
  return await getResData(getAndesAdsResultHistoryEyeParameters, { historyId, signal, probe }, false, false, true);
}

// ADS eye diagram - end-to-end channel
export async function getEndToEndAdsEyeDiagram({ endToEndChannelId, signal, probe }) {
  return await getResDataArrayBuffer(getAndesEndToEndAdsEyeDiagram, { endToEndChannelId, signal, probe });
}

export async function getEndToEndAdsHisEyeDiagram({ historyId, signal, probe }) {
  return await getResDataArrayBuffer(getAndesEndToEndAdsHisEyeDiagram, { historyId, signal, probe });
}

export async function getEndToEndAdsEyeParameters({ endToEndChannelId, signal, probe }) {
  return await getResData(getAndesEndToEndAdsEyeParameters, { endToEndChannelId, signal, probe });
}

export async function getEndToEndAdsHistoryEyeParameters({ historyId, signal, probe }) {
  return await getResData(getEndToEndAndesAdsHistoryEyeParameters, { historyId, signal, probe });
}

// HSPICE eye diagram - channel
export async function getHspiceResultEyeDiagram({ channelId, signal }) {
  return await getResDataArrayBuffer(getAndesHspiceResultEyeDiagram, { channelId, signal });
}

export async function getHspiceResultEyeParameters({ channelId, signal }) {
  return await getResData(getAndesHspiceResultEyeParameters, { channelId, signal });
}

export async function getHspiceResultHistoryEyeDiagram({ historyId, signalName, type }) {
  return await getResDataArrayBuffer(getHistoryChannelResultList, { historyId, signalName, type, responseType: 'arraybuffer' });
}

export async function getHspiceResultHistoryParameters({ historyId, signalName, type }) {
  return await getResData(getHistoryChannelResultList, { historyId, signalName, type });
}
// HSPICE eye diagram - end-to-end channel
export async function getHspiceEndToEndChannelEyeDiagram({ endToEndChannelId, displayMode, signalName, type }) {
  return await getResDataArrayBuffer(getEndToEndChannelResultList, { endToEndChannelId, displayMode, signalName, type, responseType: 'arraybuffer' });
}

export async function getHspiceEndToEndChannelEyeParameters({ endToEndChannelId, displayMode, signalName, type }) {
  return await getResData(getEndToEndChannelResultList, { endToEndChannelId, displayMode, signalName, type });
}

export async function getHspiceEndToEndHistoryEyeDiagram({ historyId, displayMode, signalName, type }) {
  return await getResDataArrayBuffer(getHistoryEndToEndChannelResultList, { historyId, displayMode, signalName, type, responseType: 'arraybuffer' });
}

export async function getHspiceEndToEndHistoryEyeParameters({ historyId, displayMode, signalName, type }) {
  return await getResData(getHistoryEndToEndChannelResultList, { historyId, displayMode, signalName, type });
}
// Bathtub
export async function getChannelBathtubRawFilePromise({ channelId, signalName }) {
  return await apiProcess(getChannelBathtubRawFile, { channelId, signalName });
}

export async function getEndToEndBathtubRawFilePromise({ endToEndChannelId, signalName }) {
  return await apiProcess(getEndToEndBathtubRawFile, { endToEndChannelId, signalName });
}
// generate result
export async function generateEyeDiagramResult(channelId, config) {
  return await apiProcess(generateEyeDiagram, { channelId, config }, false, true);
}

export async function generateTDRSBRResult(params, isEndToEnd, sweepId) {

  if (sweepId) {
    return await apiProcess(generateSweepTDRSBR, { params, sweepId });
  }

  if (isEndToEnd) {
    return await apiProcess(generateEndToEndTDRSBR, params, false, true);
  } else {
    return await apiProcess(generateTDRSBR, params, false, true);
  }
}

// TDR/SBR
export async function getTDRSBRSettingData(id, isEndToEnd, sweepId) {

  if (sweepId) {
    return await apiProcess(getSweepTDRSBRSetting, sweepId);
  }

  if (isEndToEnd) {
    return await apiProcess(getEndToEndTDRSBRSetting, id)
  } else {
    return await apiProcess(getTDRSBRSetting, id);
  }
}